import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { ControleQuinquennalApi } from "../controle-quinquennal.api";
import { controleQuinquennalKeys } from "./controle-quinquennal.keys";

export const useCQPersonnesAssujettiesQuery = (
  millesime: number,
  siren: string,
  search: string,
  limit: number
) => {
  return useQuery({
    queryKey: controleQuinquennalKeys.personneAssujetties(
      millesime,
      siren,
      search,
      limit
    ),
    queryFn: () =>
      ControleQuinquennalApi.listCQPersonnesAssujetties(
        millesime,
        siren,
        search,
        limit
      ),
    placeholderData: keepPreviousData,
    staleTime: Infinity,
    enabled: !!siren,
  });
};
